import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Container, Row } from 'react-bootstrap';
import UserEditForm from './user-edit-form';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import { doPseudoLogin, getUserEdit } from '../../../../actions/users';
import Can from '../../../common/guards/can';
import Button from '../../../common/button';
import { GROUP_ABM, GROUP_RBM, GROUP_RDR, GROUP_SUPER, GROUP_KACE } from '../../../../data/userGroups';

import './styles.css';

class EditUser extends Component {
  isRep = userGroup => !![GROUP_ABM, GROUP_RBM, GROUP_RDR, GROUP_KACE].find(group => group === userGroup.toLowerCase());

  isSuperAdmin = userGroup => GROUP_SUPER === userGroup.replace(' ', '_').toLowerCase();

  onPseudoLogin = (user) => {
    const userGroupName = user.attributes['user-group-name'];
    const { currentUser } = this.props;
    const isSuperAdmin = this.isSuperAdmin(userGroupName);
    const isYourself = user.attributes.email === currentUser.attributes.email;

    if (isSuperAdmin || isYourself) {
      return false;
    }

    doPseudoLogin(this.id);

    return true;
  };

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    this.id = +this.props.match.params.id;

    if (this.id) {
      dispatch(getUserEdit(this.id));
    } else {
      dispatch(actions.reset('deep.admin_user.edit'));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.admin_user.edit'));
    dispatch({ type: 'CLEAR_EDIT_USER' });
  }

  render() {
    const { user, currentUser } = this.props;
    const isSuperAdmin = user.attributes['user-group-id'] === 1;
    const isYourself = user.attributes.email === currentUser.attributes.email;

    return (
      <Container fluid className="users">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/users"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle>
                Add/Edit user
              </PageTitle>
              <Can action={'rep-pseudo-login-read,rep-pseudo-login-write,pseudo-login-read,pseudo-login-write'} subjectClass="web_app">
                <Button
                  className="red-ghost-btn pseudo-login"
                  onClick={() => this.onPseudoLogin(user)}
                  hidden={isSuperAdmin || isYourself}
                >
                  Pseudo log in
                </Button>
              </Can>
            </div>
          </Col>
        </Row>
        {
          user && <UserEditForm edit={!!this.id} id={this.id} user={user}/>
        }
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  user: state.users.user,
  currentUser: state.viewConfig.profile,
  fetched: state.users.fetched,
  fetching: state.users.fetching,
});

export default connect(mapStateToProps)(EditUser);
